// extracted by mini-css-extract-plugin
export default {"delete_item_button":"DeleteItemIconButton_delete_item_button__NlBrG"};